import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
    }

    unitPrice() {
        let price = this.element.querySelector('input[name="full_price"]').value;

        return parseInt(price); // Convert to cents to avoid floating number problems
    }

    calculateAmount(unitPrice, amount) {
        if (unitPrice && amount) {
            return unitPrice * amount;
        }
        return null;
    }

    syncWithForm(value) {
        const formAmount = document.querySelector('form input[name="amount"]');

        if (formAmount) {
            formAmount.value = value;
        }
    }

    handleAmountChange(e) {
        const amount = e.target.value;
        const sum = this.calculateAmount(this.unitPrice(), amount);
        const fullCartSumTarget = this.element.querySelector('#cart-sum-target-full');

        this.syncWithForm(amount)

        if (!sum) {
            return;
        }

        fullCartSumTarget.innerText = (sum / 100).toFixed(2);
    }
}
